import styled from 'styled-components';
import sizes from 'styles/sizes';
import { BrandCode, CruiseHighlightShape } from 'types';
import { CruiseHighlightListBase, CruiseHighlightPill } from '../../CruiseHighlightList/CruiseHighlightList.styles';

export const RefinedCruiseHighlightListBase = styled(CruiseHighlightListBase)`
	padding-bottom: 0;
	padding-left: 20px;
	padding-right: 20px;

	@media (min-width: ${sizes.media.tabletLandscape}px) {
		position: absolute;
		width: 55%;
	}

	@media (min-width: ${sizes.media.mediumMaxWidth}px) {
		padding-top: 20px;
	}

	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
      @media (min-width: ${sizes.media.tabletLandscape}px) and (max-width: ${sizes.media.mediumMaxWidth}px) {
        justify-content: flex-end;
        left: 25%;
        width: 30%;
      }
    `,
			[BrandCode.RoyalCaribbean]: `
      position: absolute;
    `,
		})[theme.brandCode]}
`;

export const RefinedCruiseHighlightPill = styled(CruiseHighlightPill)`
	${({ highlight }) => {
		if (highlight.shape === CruiseHighlightShape.Inclined) {
			return `
        height: 24px;

        &:first-of-type {
          margin-left: 4px;
        }
      `;
		}

		return `
      height: 25px;
    `;
	}}

	${({ highlight, theme }) =>
		({
			[BrandCode.Celebrity]: `
      @media (min-width: ${sizes.media.tabletLandscape}px) {
        background-color: ${highlight.backgroundColor ?? 'rgba(255, 255, 255,  .85)'};
        border-color: ${highlight.borderColor ?? theme.palette.special.main};
        color: ${highlight.textColor ?? theme.palette.special.main};
      }

      ${
				highlight.shape === CruiseHighlightShape.Inclined &&
				`
        &:first-of-type {
          @media (min-width: ${sizes.media.tabletLandscape}px) and (max-width: ${sizes.media.mediumMaxWidth}px) {
            margin-left: 0
          }
        }
      `
			}
    `,
			[BrandCode.RoyalCaribbean]: '',
		})[theme.brandCode]}
`;
